import { mountAdditionalVueInstance } from '@/utils/init-vue-helpers';

mountAdditionalVueInstance({
  fn: () => import('@/features/application-announcements/application-announcements.vue'),
  htmlElementId: 'vue-app-application-announcements'
})